const config = {
    id: 19,
    name: "APP跳转",
    type: 1,
    module_code: "jump_app",
    icon: "icon-tms-bottom_nav",
    font_icon: "&#xe732;",
    style_type: 1,
    link_type: 1,
    link_data: [{
        memo: "建议尺寸：750px*184px"
    }],
    property_data: {
        border_spacing_type: 1
    }
};

export default config;